





























































































import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { LocaleMessages } from 'vue-i18n';

@Component({
  components: {
    IconClose: () => import('@/components/IconClose.vue'),
  },
})
export default class TextField extends Vue {
  @Model('change', { type: [String, Object] }) value!:
    | string
    | { text: string };
  @Prop({ type: [String, Object], required: true }) label!:
    | string
    | LocaleMessages;
  @Prop({ type: String, default: 'text' }) type!: string;
  @Prop({ type: Boolean, default: false }) disabled!: string;
  @Prop({ type: Boolean, default: false }) readonly!: string;
  @Prop({ type: Boolean, default: false }) showClearButton!: boolean;
  @Prop({ type: String, required: true }) name!: string;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }
}
